import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

// ------------------------------------------------------------
// utils
// ------------------------------------------------------------
const select = (selector) => document.querySelector(selector)
const selectAll = (selector) => document.querySelectorAll(selector)

// ------------------------------------------------------------
// set vh
// ------------------------------------------------------------
const setVh = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
setVh()
window.addEventListener("resize", setVh)

// ------------------------------------------------------------
// Init 
// ------------------------------------------------------------
const DOMContentLoaded = () => {
  const body = select('body')

  // ------------------------------------------------------------
  // megamenu
  // ------------------------------------------------------------
  const megaLinks = selectAll('.js-mega-link')
  const mega = select('.header__mega')
  const megaLists = selectAll('.header__mega__list')
  let lastHoveredLink
  if (mega) {
    megaLinks.forEach((link, index) => {
      link.addEventListener('mouseenter', () => {
        body.classList.add('megamenu-open')
        link.classList.add('active')
        megaLists[index].classList.add('active')
        lastHoveredLink = index
      })
      link.addEventListener('mouseleave', () => {
        body.classList.remove('megamenu-open')
        link.classList.remove('active')
        megaLists[index].classList.remove('active')
      })
    })
    mega.addEventListener('mouseenter', () => {
      megaLinks[lastHoveredLink].classList.add('active')
      megaLists[lastHoveredLink].classList.add('active')
    })
    mega.addEventListener('mouseleave', () => {
      megaLinks[lastHoveredLink].classList.remove('active')
      megaLists[lastHoveredLink].classList.remove('active')
    })
  }
  // ------------------------------------------------------------
  // set font weight of english letters to 600
  // ------------------------------------------------------------
  // const setFontWeight = (arr, fontWeight) => {
  //   arr.forEach((container) => {
  //     const english = container.innerHTML.match(/(?<!<br>)([a-zA-Z0-9]+)(?![^<]*>)/g)
  //     if (english) {
  //       english.forEach((word) => {
  //         const regex = new RegExp(`(?<!<br>)(${word})(?![^<]*>)`, 'g')
  //         container.innerHTML = container.innerHTML.replace(regex, `<span class="fw-${fontWeight}">$1</span>`)
  //       })
  //     }
  //   })
  // }
  const setFontWeight = (arr, fontWeight) => {
    arr.forEach((container) => {
      // Extracting words using a regular expression that's compatible with older browsers
      const english = container.innerHTML.match(/[a-zA-Z0-9]+/g)
      if (english) {
        english.forEach((word) => {
          // Create a regex that matches the word but not if it's inside an HTML tag
          // This approach avoids using lookbehind
          const regex = new RegExp(`(\\b${word}\\b)(?![^<]*>)`, 'g')
          container.innerHTML = container.innerHTML.replace(regex, `<span class="fw-${fontWeight}">$1</span>`)
        })
      }
    })
  }
  setFontWeight(selectAll('.js-ajustFw600'), 600)

  // ------------------------------------------------------------
  // menu
  // ------------------------------------------------------------
  const menu = select('.menu')
  if (menu) {
    const menuBtn = select('.menu__button')
    const spans = selectAll('.menu__button span')
    const menuBtnTL = gsap.timeline({
      paused: true,
      reversed: true,
      defaults: {
        duration: 0.2,
        ease: "circIn",
      },
    })
    menuBtnTL
      .from(spans[0], { y: '-0.4rem' })
      .from(spans[2], { y: '0.4rem' }, "<")
      .to(spans[1], { opacity: 0 })
      .to(spans[0], { rotate: "45deg" })
      .to(spans[2], { rotate: "-45deg" }, "<")
      .to(menuBtn, 0.7, { backgroundColor: "#cecece", borderColor: "#cecece" }, 0)

    const menuTL = gsap.timeline({ paused: true, reversed: true, })
    menuTL
      .set(menu, { pointerEvents: 'auto' })
      .to(menu, 0.7, { opacity: 1, ease: "power2.inOut" })
    menuBtn.addEventListener('click', () => {
      menuBtnTL.reversed() ? menuBtnTL.play() : menuBtnTL.reverse()
      menuTL.reversed() ? menuTL.play() : menuTL.reverse()
      body.classList.toggle("menu-open")
    })
  }

  // ------------------------------------------------------------
  // modal
  // ------------------------------------------------------------
  const modal = select('.js-modal')
  if (modal) {
    const opens = selectAll('.js-modal-open')
    const close = select('.js-modal-close')
    const modalTL = gsap.timeline({ paused: true })
    modalTL
      .set(modal, { pointerEvents: 'auto' })
      .to(modal, 0.7, { opacity: 1, ease: "power2.inOut" })
    opens.forEach((open) => {
      open.addEventListener('click', () => {
        modalTL.play()
        body.classList.add('modal-open')
      }
      )
    })
    close.addEventListener('click', () => {
      modalTL.reverse()
      body.classList.remove('modal-open')
    }
    )
  }

  // ------------------------------------------------------------
  // scrolled 100vh
  // ------------------------------------------------------------
  ScrollTrigger.create({
    start: window.innerHeight / 3,
    onEnter: () => body.classList.add('scrolled'),
    onLeaveBack: () => body.classList.remove('scrolled'),
  })
  // ------------------------------------------------------------
  // Window load
  // ------------------------------------------------------------
  const load = () => {
    // ------------------------------------------------------------
    // News detail slider
    // ------------------------------------------------------------
    const newsDetailSlider = select('.newsDetail__modal__slider')
    if (newsDetailSlider) {
      const swiper = new Swiper(newsDetailSlider, {
        modules: [Navigation],
        loop: true,
        navigation: {
          nextEl: '.newsDetail__modal__slider__next',
          prevEl: '.newsDetail__modal__slider__prev',
        },
      })
    }
    // ------------------------------------------------------------
    // match height of info with picture element on mobile
    // ------------------------------------------------------------
    const newsPics = selectAll('.news__index__item__picture')
    const newsInfos = selectAll('.news__index__item__info')
    const marchHeight = () => {
      newsPics.forEach((pic, index) => {
        const info = newsInfos[index]
        if (window.innerWidth < 768) {
          info.style.height = `${pic.offsetHeight}px`
        } else {
          info.style.height = ""
        }
      })
    }
    marchHeight()
    window.addEventListener('resize', marchHeight)
  }
  window.addEventListener("load", load)
}

document.addEventListener("DOMContentLoaded", DOMContentLoaded)